<template>
  <div id="form-page">
    <b-card>
      <b-row class=" mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/financial-journal/account-list">Account List</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
        <b-row>
          <b-col md="6">
            
          </b-col>
        </b-row>

    </b-card>
  </div>
</template>

<script>
export default {
  name: 'form-account',
  components: {},
  data(){
    return {
      loadingButton: false,
      isLoading: false
    }
  }
}
</script>